import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { ButtonEdge } from "Components/elements/RVFlow/Shared/FlowEdges/FlowEdges";
import { removeElementById, selectConnectingNodesFrom } from "Services/state/journeys/JourneyStateSlice";

export interface EdgeProps {
    id: string;
    sourceX: any;
    sourceY: any;
    targetX: any;
    targetY: any;
    sourcePosition: any;
    targetPosition: any;
    style?: any;
    markerEnd?: any;
}

export function JourneyButtonEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
}: EdgeProps): JSX.Element {
    const dispatch = useDispatch();
    const connectingNodesFrom = !!useSelector(selectConnectingNodesFrom);

    const handleRemoveEdge = useCallback(() => {
        dispatch(removeElementById(id));
    }, [dispatch, id]);

    return (
        <ButtonEdge
            id={id}
            sourceX={sourceX}
            sourceY={sourceY}
            targetX={targetX}
            targetY={targetY}
            sourcePosition={sourcePosition}
            targetPosition={targetPosition}
            style={style}
            markerEnd={markerEnd}
            connectingNodesFrom={connectingNodesFrom}
            onRemoveEdge={handleRemoveEdge}
        ></ButtonEdge>
    );
}
